
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { map, mergeMap, tap } from 'rxjs/operators';

import { GetCitiesService } from '../get-cities.service';
import { SpinnerService } from '../spinner/spinner.service';

import { AuthService } from './auth.service';
import { from } from 'rxjs';
import { ServiceAccessEnableToggleService } from 'src/app/service-access-disabled/service-access-enable-toggle.service';
import { ROUTES_URLS } from '../constants';

export interface LoginPayload {
    email: string;
    password: string;
}

@Injectable()
export class AuthHelper {

    constructor(
        private readonly authService: AuthService,
        private readonly router: Router,
        private readonly citiesService: GetCitiesService,
        private readonly spinnerService: SpinnerService,
        private readonly serviceAccessEnableToggleService: ServiceAccessEnableToggleService
    ) { }

    initLogin() {
        from(this.authService.initOAuthFlow())
            .pipe(
                tap(() => this.spinnerService.change(true)),
                mergeMap(redirectUri => this.citiesService.getCities().pipe(map((cities: any) => ({ cities, redirectUri }))))
            )
            .subscribe(({ cities, redirectUri }) => {
                this.spinnerService.change(false);

                if (!this.authService.getCityId()) {
                    this.authService.setCityId(String(cities[0].id));
                }

                this.setRedirection(cities, redirectUri);
            }, error => {
                this.spinnerService.change(false);
                this.router.navigate(['/auth-error'], { queryParams: { message: error } });
            });
    }

    setRedirection(cities, redirectUri) {
        this.serviceAccessEnableToggleService.serviceAccessEnableCheck({
            supply_gate_city: this.authService.getUserInfo()?.city_id,
            country_code: this.authService.getUserInfo()?.city?.country?.code,
          }).subscribe((enabled: boolean) => {
            if (enabled) {
                this.citiesService.citiesList(cities);
                const redirectUriPath: string = redirectUri.path;
                const routerPath: string = redirectUriPath.indexOf(ROUTES_URLS.service_access_disabled) > -1 ? '' : redirectUriPath;
                this.router.navigate([routerPath], { queryParams: redirectUri.queryParams });
            } else {
                this.router.navigate([`/${ROUTES_URLS.service_access_disabled}`]);
            }
          });
    }

}
